import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import _ from 'lodash';
import React, { useState } from 'react';

import withTranslation from '../../../../components/withTranslation';
import DashboardDialog from '../DashboardDialog';

const DonutChartEdit = ({ part, tab, onAccept, onCancel, translateString }) => {
  const { graph } = tab;
  const [days, setDays] = useState(graph.days);
  const [data, setData] = useState({ part, tab });

  function handleDataChange(updates) {
    const clonedData = JSON.parse(JSON.stringify(data));

    updates.forEach(({ path, value }) => {
      _.set(clonedData, path, value);
    });

    setData(clonedData);
  }

  function handleDaysChange(e) {
    const { value } = e.target;
    setDays(value);
    handleDataChange([
      { path: 'tab.subtitle', value: `in the last ${value} days` },
      { path: 'tab.graph.days', value },
    ]);
  }

  const cancelButton = {
    label: translateString('Cancel'),
    onClick: onCancel,
  };

  const acceptButton = {
    label: translateString('Accept'),
    onClick: () => onAccept(data),
  };

  return (
    <DashboardDialog
      data={data}
      buttonProps={[cancelButton, acceptButton]}
      onChange={handleDataChange}
      onClose={onCancel}
    >
      <Select
        fullWidth
        label={translateString('Number of Days')}
        placeholder={translateString('Select the number of days')}
        value={days}
        onChange={handleDaysChange}
      >
        {graph.options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </DashboardDialog>
  );
};

export default withTranslation(DonutChartEdit);
